import { ɵisMessagingSupportedFactory } from '@angular/fire';

export const isSupported = ɵisMessagingSupportedFactory.async;
